<script>
  import responsive from '@/js/utils/responsive';

  import PageHero from '$lib/page/Hero.svelte';
  import VacancyTypo from '$lib/vacancy/Typo.svelte';
  import VacancyBenefits from '$lib/vacancy/benefits/Index.svelte';
  import VacancyList from '$lib/vacancy/List.svelte';
  import VacancyMore from '$lib/vacancy/More.svelte';
  import VacancyHeading from '$lib/vacancy/VacancyHeading.svelte';
  import Seo from '$lib/Seo.svelte';
  import Faq from '$lib/faq/Index.svelte';

  export let page_hero;
  export let heading;
  export let typo;
  export let benefits;
  export let vacancies;
  export let more;
  export let faq;
  export let seo;

  let innerWidth = 0;
  $: mobile = innerWidth <= responsive.s;
</script>

<svelte:window bind:innerWidth />

<div class="page-career">
  <PageHero hero={page_hero} />
  {#if heading}
    <VacancyHeading {heading} />
  {/if}
  {#if benefits && mobile}
    <VacancyBenefits {...benefits} />
  {/if}
  {#if typo}
    <VacancyTypo {...typo} />
  {/if}
  {#if benefits && !mobile}
    <VacancyBenefits {...benefits} />
  {/if}
  {#if vacancies}
    <VacancyList {...vacancies} />
  {/if}
  {#if more}
    <VacancyMore {...more} />
  {/if}
  {#if seo}
    <Seo {seo} />
  {/if}
  {#if faq}
    <Faq {faq} />
  {/if}
</div>

<style lang="scss">
  :global .page-career .page-hero {
    .page-hero__image-small {
      display: none;
    }
  }
</style>
